<template>
  <div class="header-wrapper">
    <navbar
      :notifications="notifications"
      :reports="reports"
      :loadingNotifications="loadingNotifications"
      :loadingReports="loadingReports"
      :pTitle="pageTitle"
      v-if="isLogged && !$store.state.sidebar.locked"
      @signoff="logout"
    />
    <!-- <div
      class="wrapper custom-header"
      v-if="isLogged && !$store.state.sidebar.locked"
    > -->
    <!-- <breadcrumbs :bcrumbs="clearedBreadcrumbList" /> -->
    <!-- <div
        class="version text-sm-right"
        style="white-space: nowrap; font-size: 10px"
      >
        Agenzia: <b>{{ agencyName }}</b>
      </div> -->
    <!-- </div> -->
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
// import Breadcrumbs from "@/components/Breadcrumbs.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    Navbar,
    // Breadcrumbs,
  },
  name: "CustomHeader",
  data() {
    return {
      breadcrumblist: null,
      // clearedBreadcrumbList: null,
      pageTitle: null,
      something: "",
      isLoading: false,
      results: {},
    };
  },
  props: {
    reports: {
      type: Number,
      default() {
        return 0;
      },
    },
    notifications: {
      type: Number,
      default() {
        return 0;
      },
    },
    loadingReports: {
      type: Boolean,
      default: false,
    },
    loadingNotifications: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapGetters("queue", ["getQueue"]),
    ...mapGetters("auth", ["isLogged", "permissions", "settings"]),
    ...mapActions("sidebar", ["saveNavbar"]),
    ...mapActions("queue", [/* "popQueue", "pushQueue", */ "emptyQueue"]),
    // openMenuDrawerFromNavbar() {
    //   debugger;
    //   this.$emit("openMenuDrawer");
    // },
    logout() {
      this.$store
        .dispatch("auth/logout")
        .then(() => {
          this.$store.dispatch("filters/removeAll");
          this.$store.dispatch("tabs/removeAll");
          this.$store.dispatch("sorts/removeAll");
          this.$store.dispatch("pagination/removeAll");
          this.$store.dispatch("queue/emptyQueue");
          this.$store.dispatch("breadcrumbs/remove");
          document.body.className = "Body";
          this.isNavClose
            ? this.saveNavbar(this.isNavClose)
            : this.saveNavbar(!this.isNavClose);
          this.$router.replace({ name: "Login" });
          this.$showSnackbar({
            preset: "success",
            text: "Uscita con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
  },
  computed: {
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    cliVer() {
      return process.env.VUE_APP_VERSION || "0";
    },
    // agencyName() {
    //   return this.$store.state.auth.settings.formatted_title;
    // },
  },
  // watch: {
  //   //Watch queue-store changes
  //   "$store.state.queue.items": {
  //     //If you want to watch nested elements, you need to use the deep flag in your watcher
  //     deep: true,
  //     handler() {
  //       this.breadcrumblist = this.getQueue();
  //       let len = this.breadcrumblist.length;
  //       this.pageTitle =
  //         len === 1 ? { text: "Dashboard" } : this.breadcrumblist[len - 1];
  //       this.clearedBreadcrumbList = this.breadcrumblist
  //         ? [...this.breadcrumblist.slice(1, this.breadcrumblist.length)]
  //         : [];
  //     },
  //   },
  // },
};
</script>
<style lang="scss" scoped>
.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.75rem;
  /* box-shadow: 0 1px 0 0 #ccc; */
  // border-bottom: 1px solid #dbdbdb;
  // margin: 0 0 1.25rem;
  margin: 0 0 1rem;
  // position: relative;
  // &:after {
  //   position: absolute;
  //   bottom: 0;
  //   left: 12px;
  //   display: block;
  //   width: calc(100% - 12px);
  //   height: 1px;
  //   content: "";
  //   background-color: #dbdbdb;
  // }
}
</style>
